import {toast} from 'react-toastify';
export const onTranslateArticle = async (query, translateProps) => {
  const {sourceLang, targetLang, targetText1, targetText2, targetText3} =
    translateProps;
  try {
    const {data} = await query({
      variables: {
        translations: [
          {sourceLang, sourceText: targetText1, targetLang},
          {sourceLang, sourceText: targetText2, targetLang},
          {sourceLang, sourceText: targetText3, targetLang},
        ],
        treatment: 'html',
      },
    });
    return {
      title: data.translateText.translations[0],
      summary: data.translateText.translations[1],
      language: targetLang,
      content: data.translateText.translations[2],
    };
  } catch (error) {
    toast.error('Something went wrong');
  }
};
